import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../images/circle-info-regular-full.svg'

function BasicInformation ({ localBasicInformation, setLocalBasicInformation }) {
  const handleFirstNameChange = event => {
    setLocalBasicInformation(event.target.value)
  }

  return (
    <section className={styles.nameComponentSection}>
      <h1 className={styles.nameComponentTitle}>Basic Information</h1>
      <div className={styles.nameComponentInputContainer}>
        <div className={styles.nameComponentInputWrapper}>
          <div className={styles.inlineLabel}>
            <label className={styles.nameComponentLabel} htmlFor='firstName'>
              Name
            </label>
            <Tooltip
              title='The name of the business.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Name help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            autoComplete='off'
            className={styles.nameComponentInput}
            placeholder='Text'
            type='text'
            value={localBasicInformation}
            onChange={handleFirstNameChange}
          />
        </div>
      </div>
    </section>
  )
}

export default BasicInformation
